import { ApolloCache, DefaultContext, MutationUpdaterFunction } from '@apollo/client';
import {
  DocumentsDocument,
  DocumentsQuery,
  DocumentsQueryVariables,
  UploadDocumentMutation,
  UploadDocumentMutationVariables,
} from 'generated/graphql';

export const updateCacheOnUpload: (
  clientId: string
) => MutationUpdaterFunction<
  UploadDocumentMutation,
  UploadDocumentMutationVariables,
  DefaultContext,
  ApolloCache<any>
> =
  clientId =>
  (cache, { data: mutationData }) => {
    if (mutationData) {
      cache.updateQuery<DocumentsQuery, DocumentsQueryVariables>(
        { query: DocumentsDocument, variables: { clientId } },
        queryData => {
          if (queryData) {
            const { uploadDocument: document } = mutationData;
            return {
              ...queryData,
              documents: {
                ...queryData.documents,
                edges: [
                  { __typename: 'DocumentEdge', node: document },
                  ...queryData.documents.edges,
                ],
              },
            };
          }
          return null;
        }
      );
    }
  };
